import React from 'react';
import { campaignService } from '../../services/campaignService';
import EventBus from '../../utils/EventBus';
import Icon from './Icon';
import styles from './ImageUpload.module.css';

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
const MAX_SIZE_BYTES = 5 * 1024 * 1024; // 5MB — generous for a notification header image

let _inputId = 0;

// Uploads directly to S3 via a presigned PUT URL (campaignService.getImageUploadUrl)
// — this app's Node backend never sees the file bytes, same pattern
// pickmywork-backend's own presigned-URL uploads use.
class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = { uploading: false };
    this.inputId = 'image-upload-' + (++_inputId);
    this.handleFile = this.handleFile.bind(this);
  }

  async handleFile(e) {
    const file = e.target.files?.[0];
    e.target.value = ''; // allow re-selecting the same file after removing it
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      EventBus.emit('toast', { type: 'error', message: 'Please pick a JPEG, PNG, WebP, or GIF image.' });
      return;
    }
    if (file.size > MAX_SIZE_BYTES) {
      EventBus.emit('toast', { type: 'error', message: 'Image must be under 5MB.' });
      return;
    }

    this.setState({ uploading: true });
    try {
      const { uploadUrl, publicUrl } = await campaignService.getImageUploadUrl(file.name, file.type);
      const putRes = await fetch(uploadUrl, { method: 'PUT', body: file, headers: { 'Content-Type': file.type } });
      if (!putRes.ok) throw new Error('Upload to S3 failed (' + putRes.status + ')');
      this.props.onChange(publicUrl);
    } catch (err) {
      EventBus.emit('toast', { type: 'error', message: err.message || 'Image upload failed.' });
    } finally {
      this.setState({ uploading: false });
    }
  }

  render() {
    const { value, label } = this.props;
    const { uploading } = this.state;

    return (
      <div className={styles.wrap}>
        {label && <label className={styles.label}>{label}</label>}
        {value
          ? (
            <div className={styles.preview}>
              <img className={styles.previewImg} src={value} alt="Uploaded" />
              <button type="button" className={styles.removeBtn} onClick={() => this.props.onChange('')}>
                <Icon name="close" size={14} />
              </button>
            </div>
          )
          : (
            <label htmlFor={this.inputId} className={[styles.dropzone, uploading ? styles.uploading : ''].join(' ')}>
              <Icon name={uploading ? 'progress_activity' : 'upload'} size={18} />
              {uploading ? 'Uploading…' : 'Click to upload an image'}
              <input
                id={this.inputId}
                className={styles.hiddenInput}
                type="file"
                accept={ALLOWED_TYPES.join(',')}
                disabled={uploading}
                onChange={this.handleFile}
              />
            </label>
          )}
      </div>
    );
  }
}

export default ImageUpload;
